<script>
    import Layout from "../../../layouts/main";
    import PageHeader from "@/components/page-header";
    import appConfig from "@/app.config";
    import Forms from "../../../../mixins/Forms";

    import axios from 'axios';

    /**
     * Ticket note template edit component
     */
    export default {
        page: {
            title: "Edit Twilio Phone Numbers",
            meta: [{name: "description", content: appConfig.description}]
        },
        components: {Layout, PageHeader},
        mixins: [Forms],
        created() {
            this.loadTwilioPhoneNumber(this.$route.params.id);
        },
        data() {
            return {
                title: "Edit Twilio Phone Number",
                items: [
                    {
                        text: "Settings",
                        href: "#"
                    },
                    {
                        text: "Edit Twilio Phone Number",
                        active: true
                    }
                ],
                twilioPhoneNumber: null,
                serverErrors: [],
                isLoading: false,
                isSaving: false
            };
        },
        methods: {
            loadTwilioPhoneNumber(id) {
               let vm = this;
               vm.twilioPhoneNumber = null;
               vm.isLoading = true;
               axios.get(API_BASE + '/twilio-phone-numbers/' + id).then(r => {
                   vm.isLoading = false;
                   vm.twilioPhoneNumber = r.data;
               }).catch(e => {
                   console.log(e);
                   vm.isLoading = false;
                   vm.setErrors(e);
               });
           },

            attemptSave() {
                this.save();
            },

            save() {
                let vm = this;
                vm.isSaving = true;
                axios.put(API_BASE + '/twilio-phone-numbers/' + this.twilioPhoneNumber.id, {
                    name: vm.twilioPhoneNumber.name,
                    phone_number: vm.twilioPhoneNumber.phone_number,
                    country_code: vm.twilioPhoneNumber.country_code
                }).then(r => {
                    vm.isSaving = false;
                    vm.$router.push('/settings/twilio-phone-numbers/');
                    this.$notify.success({
                        title: 'Success!',
                        message: 'Phone number updated successfully'
                    });
                }).catch(e => {
                    console.log(e);
                    vm.isSaving = false;
                    vm.setErrors(e);
                });
            }
        }
    };
</script>

<template>
    <Layout>
        <PageHeader :title="title" :items="items"/>
        <errors :error-list="serverErrors"></errors>
        <loading-screen :is-loading="isLoading||isSaving"></loading-screen>
        <div class="row" v-if="twilioPhoneNumber">
            <div class="col-lg-12">
                <div class="card">
                    <div class="card-body">
                        <!--            <h4 class="card-title mb-4">Ticket Details</h4>-->
                        <form @submit.prevent="attemptSave">
                            <div class="form-group row mb-4">
                                <label for="name" class="col-form-label col-lg-2">Name</label>
                                <div class="col-lg-10">
                                    <input
                                            id="name"
                                            name="name"
                                            type="text"
                                            class="form-control"
                                            v-model="twilioPhoneNumber.name"
                                            autofocus
                                    />
                                </div>
                            </div>
                            <div class="form-group row mb-4">
                                <label for="countryCode" class="col-form-label col-lg-2">Country Code</label>
                                <div class="col-lg-10">
                                    <input
                                            id="countryCode"
                                            name="name"
                                            type="text"
                                            class="form-control"
                                            v-model="twilioPhoneNumber.country_code"
                                    />
                                </div>
                            </div>
                            <div class="form-group row">
                                <label for="phone_number" class="col-form-label col-lg-2">Phone Number</label>
                                <div class="col-lg-10">
                                    <input
                                            id="phone_number"
                                            name="phone_number"
                                            type="text"
                                            class="form-control"
                                            v-model="twilioPhoneNumber.phone_number"
                                    />
                                </div>
                            </div>
                        </form>
                        <div class="row justify-content-end">
                            <div class="col-lg-10">
                                <button type="submit" class="btn btn-itg-dark" @click.prevent="attemptSave">Update</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- end row -->
    </Layout>
</template>

<style scoped>
</style>
